import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, AccordionProps } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface AccordionItemProps extends AccordionProps {
  title: string
  expanded: boolean
  onToggle: () => void
}

export const AccordionItem: React.FC<AccordionItemProps> = ({ title, children, expanded, onToggle }) => {
  return (
    <Accordion expanded={expanded} onChange={onToggle} style={{ width: '100%' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails aria-label='AccordionDetails' style={{ padding: 20 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}
